<script>
// Lucide-Linien-Icon (R3) als funktionale Komponente: <app-icon name="refresh" :size="16" />
// Strich 1,75, bei Größen bis 14 px Strich 2; Farbe über currentColor (oder color, auch als Token „--ink-3“).
// Übernimmt class/style des Aufrufers; per CSS gesetzte width/height haben Vorrang vor den Attributen.
import icons from './icons';

const warned = {};

export default {
  name: 'AppIcon',
  functional: true,
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 18 },
    color: { type: String, default: null },
    strokeWidth: { type: [Number, String], default: null }
  },
  render(h, { props, data }) {
    const size = Number(props.size) || 18;
    const strokeWidth = props.strokeWidth !== null && props.strokeWidth !== undefined && props.strokeWidth !== ''
      ? props.strokeWidth
      : (size <= 14 ? 2 : 1.75);
    const inner = icons[props.name];
    if (inner === undefined && !warned[props.name]) {
      warned[props.name] = true;
      console.warn('[AppIcon] unbekanntes Icon: ' + props.name);
    }
    const style = [{ flex: 'none' }];
    if (props.color) {
      style.push({ color: props.color.indexOf('--') === 0 ? 'var(' + props.color + ')' : props.color });
    }
    if (data.style) {
      style.push(data.style);
    }
    return h('svg', {
      staticClass: data.staticClass ? 'app-icon ' + data.staticClass : 'app-icon',
      class: data.class,
      staticStyle: data.staticStyle,
      style,
      attrs: Object.assign({}, data.attrs, {
        width: size,
        height: size,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': strokeWidth,
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'aria-hidden': 'true',
        focusable: 'false'
      }),
      domProps: { innerHTML: inner || '' },
      on: data.on
    });
  }
};
</script>
